import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "antd";
import { FC } from "react";
import { Props } from "./types";

const DownloadableImage: FC<Props> = ({ src, alt, style }) => {
  const handleDownload = async () => {
    try {
      const response = await fetch(src);
      if (!response.ok) {
        throw new Error("Image download failed");
      }
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = "image";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch {
      window.open(src, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <img src={src} alt={alt} style={style} />
      <Button
        onClick={handleDownload}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "5px 10px",
          cursor: "pointer",
        }}
      >
        <FontAwesomeIcon icon={faDownload} />
      </Button>
    </div>
  );
};

export default DownloadableImage;
